import React, { Component } from 'react';
import { connect } from 'react-redux';
import actions from '../actions/address.actions';
import {actions as newRequestActions} from './CreateRequest/new-request.actions';
import { Col, Row, Form, Modal, Select, Input  } from 'antd';
import { dspxGetChildrens, dspxGetRoomOptions, dspxGetWorkerChildrens } from '../helpers/dspx-utils'
import {ReactComponent as EditRequestIcon } from '../resource/forms/ListEdit.svg';
import { MODAL_UNSAVED_DATA_WARNING_TITLE, UNSAVED_DATA_WARNING_TEXT } from '../constants/text.constants';
 
const confirm = Modal.confirm;

const AddressForm = Form.create()(
	class extends React.Component {

		handleAddrStreetChange = (value) => {
			this.props.form.resetFields(['addressId'])
			this.props.form.resetFields(['serviceId'])
			this.props.form.resetFields(['typeId'])
			this.props.form.resetFields(['masterId'])
			this.props.form.resetFields(['executerId'])
			this.props.dispatch(newRequestActions.applyAddrStreet(value));
		}
		
		handleAddrBuildingChange = (value) => {
			this.props.form.resetFields(['addressId'])
			this.props.form.resetFields(['serviceId'])
			this.props.form.resetFields(['typeId'])
			this.props.form.resetFields(['masterId'])
			this.props.form.resetFields(['executerId'])
			this.props.dispatch(newRequestActions.applyAddrBuilding(value))
		}

		handleAddrFlatChange = (value) => {
			this.props.form.resetFields(['masterId'])
			this.props.form.resetFields(['executerId'])
			this.props.dispatch(newRequestActions.applyAddrFlat(value));
		}

		handleServiceChange = (value) => {
			this.props.form.resetFields(['typeId'])
			this.props.form.resetFields(['masterId'])
			this.props.form.resetFields(['executerId'])
			this.props.dispatch(newRequestActions.setWorkerValue(undefined))
			this.props.dispatch(newRequestActions.setExecuterValue(undefined))
			this.props.dispatch(newRequestActions.applyService(value));
		}

		handleSubserviceChange = (value) => {
			this.props.form.resetFields(['masterId'])
			this.props.form.resetFields(['executerId'])
			//this.props.dispatch(newRequestActions.setSubserviceValue(value));
			this.props.dispatch(newRequestActions.applySubservice(value));
		}

		handleExecuterChange = v => {
			this.props.dispatch(newRequestActions.setExecuterValue(v))
			//this.setEventMarks()
		}

		handleWorkerChange = v => {
			this.props.dispatch(newRequestActions.setWorkerValue(v))
		}

		render() {
			const { visible, onCancel, onCreate, form, fprops, confirmLoading } = this.props
			const request = fprops.request
			const serviceOnly = request.serviceOnly
			const { getFieldDecorator } = form;

			//const isExecuter = this.props.form.getFieldValue('executerId')
			//const edate = this.props.form.getFieldValue('executeMoment')

			return (
				<Modal className='dspx-icon-header'
					width={520}
					visible={visible}					
					title={<span><EditRequestIcon style={{ height: 40, verticalAlign:'middle', marginRight: 10 }}/>Изменение заявки</span>}
					confirmLoading={confirmLoading}
					onCancel={onCancel}
					onOk={onCreate} >
					<Form layout="vertical">
						<Form.Item style={{margin:0,padding:0 }}>
							{getFieldDecorator('request', { initialValue: request.id })(
								<Input type='hidden' />)}
						</Form.Item>
						{ request.serviceOnly &&
						<Form.Item style={{margin:0,padding:0 }}>
							{getFieldDecorator('addressId', { initialValue: request.addressId })(
								<Input type='hidden' />)}
						</Form.Item>}

						{ !request.serviceOnly && <Row gutter={16}> 
							<Col span={24}>
								<Form.Item label="Адрес">
									<Input.Group compact>
										<Select
											showSearch
											style={{ width: 248 }}
											placeholder="Улица"
											notFoundContent='нет данных'
											value={(fprops.listAddrStreet && fprops.listAddrStreet.some(e => e.id == fprops.valueAddrStreet)) 
												? ''+fprops.valueAddrStreet : undefined}
											onChange={this.handleAddrStreetChange}
											optionLabelProp="label"
											optionFilterProp="searchtext" >
											{dspxGetChildrens(fprops.listAddrStreet)}
										</Select>
										<Select
											showSearch
											style={{ width: 100 }}
											notFoundContent='нет данных'
											placeholder="Дом"
											optionFilterProp="searchtext"
											value={(fprops.listAddrBuilding && fprops.listAddrBuilding.some(e => e.id == fprops.valueAddrBuilding)) 
												? ''+fprops.valueAddrBuilding : undefined}
											onChange={this.handleAddrBuildingChange} >
											{dspxGetChildrens(fprops.listAddrBuilding)}											
										</Select>
										{getFieldDecorator('addressId', {
											initialValue: (fprops.listAddrFlat && fprops.listAddrFlat.some(e => e.id == fprops.valueAddrFlat)) 
												? ''+fprops.valueAddrFlat : undefined,
										rules: [{ required: true, message: 'Пожалуйста, выберите адрес.' }]
										})(
											<Select
												showSearch
												notFoundContent='нет данных'
												style={{ width: 120 }}
												placeholder="Помещения"
												dropdownMatchSelectWidth={false}
												onChange={this.handleAddrFlatChange} 
												optionFilterProp="searchtext" >
												{dspxGetRoomOptions(fprops.listAddrFlat)}
											</Select>)}
									</Input.Group>
								</Form.Item>
							</Col>
							</Row> }

						<Row gutter={16}>
							<Col span={24}>
								<Form.Item label="Услуга">
									<Input.Group compact>
										<Select
											showSearch
											style={{ width: 200 }}
											placeholder="услуга"
											notFoundContent='нет данных'
											value={(fprops.listService && fprops.listService.some(e => e.id == fprops.valueService)) 
													? ''+fprops.valueService : undefined}
											onChange={this.handleServiceChange}
											optionFilterProp="searchtext" >
											{dspxGetChildrens(fprops.listService)}
										</Select>
										{getFieldDecorator('typeId', {											
											initialValue: (fprops.listSubservice && fprops.listSubservice.some(e => e.id == fprops.valueSubservice)) 
												? ''+fprops.valueSubservice : undefined,
											rules: [{ required: true, message: 'Пожалуйста, выберите услугу' }]
										})(
											<Select
												showSearch
												style={{ width: 266 }}
												placeholder="причина"
												notFoundContent='нет данных'
												optionFilterProp="searchtext" 
												onChange={this.handleSubserviceChange}
												>
												{dspxGetChildrens(fprops.listSubservice)}
											</Select>)}
									</Input.Group>
								</Form.Item>
							</Col>
						</Row>
						<Row gutter={16}>
							<Col span={12}>
								<Form.Item label="Мастер">
									{getFieldDecorator('masterId', {										
										   initialValue:
                      fprops.listWorker &&
                      fprops.listWorker.some(
                        (e) => e.id == fprops.valueWorker
                      )
                        ? '' + fprops.valueWorker
                        : fprops.listWorker &&
                          fprops.listWorker[0] &&
                          fprops.listWorker[0].autoSet
                        ? fprops.listWorker[0].id + ''
                        : undefined,
									})(
										<Select											
											showSearch
											allowClear={true}
											placeholder="мастер"
											notFoundContent='нет данных'
											optionLabelProp="label"											
											optionFilterProp="searchtext" 
											onChange={this.handleWorkerChange}>
											{dspxGetWorkerChildrens(fprops.listWorker)}
										</Select>)}
								</Form.Item>
							</Col>
							<Col span={12}>
								<Form.Item label="Исполнитель">
									{getFieldDecorator('executerId', {
											   initialValue:
                    fprops.listExecuter &&
                    fprops.listExecuter.some(
                      (e) => e.id == fprops.valueExecuter
                    )
                      ? '' + fprops.valueExecuter
                      : fprops.listExecuter &&
                        fprops.listExecuter[0] &&
                        fprops.listExecuter[0].autoSet
                      ? fprops.listExecuter[0].id + ''
                      : undefined,
										})(
										<Select
											showSearch
											allowClear={true}
											placeholder="исполнитель"
											notFoundContent='нет данных'
											optionLabelProp="label"
											optionFilterProp="searchtext" 
											onChange={this.handleExecuterChange}>
											{dspxGetWorkerChildrens(fprops.listExecuter)}
										</Select>)}
								</Form.Item>
							</Col>
						</Row>
					</Form>
				</Modal>
			);
		}
	});

class AddressContainer extends Component {
	state = {
		confirmLoading: false,
	};

  handleCancel = () => {
    return new Promise((resolve) => {
      const form = this.formRef && this.formRef.props && this.formRef.props.form;
      const hasTouchedFields = form && typeof form.isFieldsTouched === 'function' ? form.isFieldsTouched() : false;

      if (hasTouchedFields) {
        Modal.confirm({
          title: MODAL_UNSAVED_DATA_WARNING_TITLE,
          content: UNSAVED_DATA_WARNING_TEXT,
          okType: 'danger',
          okText: 'Да',
          cancelText: 'Отмена',
          onOk: () => {
            this.resetAndClose();
            resolve(true);
          },
          onCancel: () => resolve(false),
        });
        return;
      }

      this.resetAndClose();
      resolve(true);
    });
  }

  resetAndClose = () => {
    const form = this.formRef && this.formRef.props && this.formRef.props.form;
    if (form) form.resetFields();
    //this.formRef.state.calendar = false;
    this.props.dispatch(actions.closeAddressModal());
  }

	handleCreate = () => {
		const form = this.formRef.props.form;
		

		form.validateFields(async (err, values) => {
			if (err) return;

			if (typeof this.props.updateAddress === 'function') {
				this.setState({
					confirmLoading: true,
				});

				await this.props.updateAddress(values);

				this.setState({
					confirmLoading: false,
				});
			} else {
				this.props.dispatch(actions.postAddress(values));
			}

			form.resetFields();
			this.props.dispatch(actions.closeAddressModal());
			}
		);
	}

	saveFormRef = (formRef) => {

		this.formRef = formRef;
	}

	render() {

		return (
			<AddressForm
				wrappedComponentRef={this.saveFormRef}
				visible={this.props.addressModalVisible}
				dispatch={this.props.dispatch}
				onCancel={this.handleCancel}
				onCreate={this.handleCreate}
				fprops={this.props}
				confirmLoading={this.state.confirmLoading}
			/>
		)
	}
}

function mapStateToProps(state) {
	const { addressStore, newRequestStore } = state
	const request = addressStore.record
	const baseValues = {
		valueWorker:newRequestStore.valueWorker,
		valueExecuter:newRequestStore.valueExecuter,
		valueService:newRequestStore.valueService,
		valueSubservice:newRequestStore.valueSubservice,
	 }
	//valueSubservice valueWorker valueExecuter valueService
	//const { listWorker, listExecuter, listService, listSubservice, valueService } = state.newRequestStore;
	//const { newRequestStore } = state.newRequestStore;

	return { ...addressStore, ...newRequestStore, request, baseValues };
}

export default connect(mapStateToProps)(AddressContainer);
